// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vue2TouchEvents from 'vue2-touch-events'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import VueGtag from 'vue-gtag'

Vue.config.productionTip = false

Vue.use(Vue2TouchEvents)
Vue.use(BootstrapVue)
Vue.use(Vuex)

// Google Analytics
// https://developers.google.com/analytics/devguides/collection/ga4
if (window.location.hostname === 'www.envirosigns.com') {
  // Global - if (this.$ga)
  Vue.prototype.$ga = true
  // https://matteo-gabriele.gitbook.io/vue-gtag/v/master/
  Vue.use(VueGtag, {
    pageTrackerExcludedRoutes: ['/'],
    config: { id: 'G-Y7DTK50SNB', send_page_view: false }
  }, router)
}

const store = new Vuex.Store({
  state: {

  },
  mutations: {

  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  computed: {
    vuex () {
      return store
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js